import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col, Typography, Modal } from 'antd';
import { color } from '../../../../../resources/color';

const { Text } = Typography;

export const BlockClaimModal = ({ open, onClose, warrantyCode, productName, fullName, telephone }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={[
        <Button key="close" type="primary" danger onClick={onClose}>
          ปิด
        </Button>,
      ]}
      centered
    >
      <div style={{ textAlign: 'center', padding: '16px 0' }}>
        <div style={{ textAlign: 'left' }}>
          <Row gutter={[8, 8]} style={{ marginBottom: '25px' }}>
            <Col span={10}>
              <Text style={{ fontSize: 14 }}>รหัสรับประกัน:</Text>
            </Col>
            <Col span={14}>
              <Text strong style={{ fontSize: 14 }}>{warrantyCode}</Text>
            </Col>

            <Col span={10}>
              <Text style={{ fontSize: 14 }}>ชื่อสินค้า:</Text>
            </Col>
            <Col span={14}>
              <Text strong style={{ fontSize: 14 }}>{productName}</Text>
            </Col>

            <Col span={10}>
              <Text style={{ fontSize: 14 }}>ชื่อ-นามสกุล:</Text>
            </Col>
            <Col span={14}>
              <Text strong style={{ fontSize: 14 }}>{fullName}</Text>
            </Col>

            <Col span={10}>
              <Text style={{ fontSize: 14 }}>เบอร์โทรศัพท์:</Text>
            </Col>
            <Col span={14}>
              <Text strong style={{ fontSize: 14 }}>{telephone}</Text>
            </Col>
          </Row>
          <Row>
            <Col span={24} style={{ textAlign: 'center' }}>
              <Text
                strong
                style={{ color: color.red, fontSize: 18 }}
              >
                ขออภัยในความไม่สะดวก
              </Text>
            </Col>
          </Row>
          <Row>
            <Col span={24} style={{ textAlign: 'center' }}>
              <Text
                strong
                style={{ color: color.red, fontSize: 18 }}
              >
                กรุณาติดต่อแอดมินก่อนเคลมสินค้ารายการนี้
              </Text>
            </Col>
          </Row>
          <Row>
            <Col span={24} style={{ textAlign: 'center' }}>
              <Text
                strong
                style={{ color: color.red, fontSize: 18 }}
              >
                ขอบคุณค่ะ
              </Text>
            </Col>
          </Row>
        </div>
      </div>
    </Modal>
  );
};

BlockClaimModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  warrantyCode: PropTypes.string,
  productName: PropTypes.string,
  fullName: PropTypes.string,
  telephone: PropTypes.string,
};

BlockClaimModal.defaultProps = {
  warrantyCode: '-',
  productName: '-',
  fullName: '-',
  telephone: '-',
};
